import { Component, ViewEncapsulation, OnInit, ViewChild, Input, Output, EventEmitter, forwardRef, SimpleChange} from '@angular/core';
import { MultiSelectComponent } from '@syncfusion/ej2-angular-dropdowns';
import { CheckBoxComponent } from '@syncfusion/ej2-angular-buttons';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, Validator, FormControl, ValidationErrors } from '@angular/forms';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiSelectDropdownComponent),
    multi: true
};
const CUSTOM_INPUT_CONTROL_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => MultiSelectDropdownComponent),
    multi: true
};
@Component({
    selector: 'multi-select-dropdown',
    templateUrl: 'multi-select-dropdown.html',
    styleUrls: ['multi-select-dropdown.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class MultiSelectDropdownComponent implements OnInit {
    // Placeholders for the callbacks which are later providesd
    // by the Control Value Accessor
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    @ViewChild('multiselect')
    private mulObj: MultiSelectComponent;
    @Input()
    public showSelectAll = false;
    @Input()
    public valueField: string;
    @Output() public CheckChange = new EventEmitter<any>();
    @Input()
    public textField: string;

    public internalValue: number[] = [];


    @Input()
    public get value(): number[] {
        return this.internalValue;
    }

    public set value(val) {
        if (val !== undefined && val != null) {
            if (this.internalValue === undefined || this.internalValue == null ) {
                this.internalValue = val;
                this.onChangeCallback(val);
            }
        } else if (this.internalValue !== undefined || this.internalValue == null) {
            this.internalValue = val;
            this.onChangeCallback(val);
        }
    }
     // Set touched on blur
     onBlur() {
        this.onTouchedCallback();
    }

    // From ControlValueAccessor interface
    writeValue(val: any) {
        if (val !== undefined && val != null) {
            if (this.internalValue === undefined || this.internalValue == null ) {
                this.internalValue = val;
            }
        } else if (this.internalValue !== undefined || this.internalValue == null) {
            this.internalValue = val;
        }
    }

    // From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    // From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    @Input()
    public dataSource: { [key: number]: Object } [] = [];

    public mode = 'CheckBox';
    public filterPlaceholder = 'Search';
    // define the data with category
    public checkFields: Object = { text: '', value: '' };

    // set the placeholder to the MultiSelect input
    public placeHolder = 'Select';
    // set the MultiSelect popup height
    public popHeight = '350px';

    ngOnInit(): void {
        this.checkFields = { text: this.textField, value: this.valueField};
    }

   public onChange(event: any) {
    this.CheckChange.emit (event);
        let newValue = event.value;
        if (newValue !== undefined && newValue != null && newValue.length == 0) {
            newValue = undefined;
        }
        this.onChangeCallback(newValue);
   }
}
